export default "__VITE_ASSET__gd_cpHoh__"